import React from 'react';
import { Field, ErrorMessage } from 'formik';
import { TextError } from '.';

export function AreasCheckboxes(props) {
    const { name, options, formik, ...rest } = props;
    return (
        <>
            <Field name={name} {...rest}>
                {({ field }) => {
                    const selected = field.value || [];
                    // The quote form runs with validateOnChange disabled, so Formik's own onChange would
                    // record the tick without clearing the "at least one body area" error, leaving the
                    // submit button disabled. Only a blur re-validates, and Safari never focuses a
                    // checkbox on click, so nothing ever cleared it there. Validate on toggle instead.
                    const handleToggle = (option) => {
                        const next = selected.includes(option)
                            ? selected.filter((area) => area !== option)
                            : [...selected, option];
                        formik.setFieldValue(name, next, true);
                        formik.setFieldTouched(name, true, false);
                    };
                    return options.map((option) => {
                        return (
                            <li className="col-6 col-lg-3 custom-checkbox" key={option}>
                                <label htmlFor={option} className="area_label">
                                    {option}
                                    <input
                                        type="checkbox"
                                        name={name}
                                        value={option}
                                        id={option}
                                        checked={selected.includes(option)}
                                        onChange={() => handleToggle(option)}
                                        onBlur={field.onBlur}
                                        disabled={selected.length >= 3 && !selected.includes(option)}
                                    />
                                    <span className="checkmark"></span>
                                </label>
                            </li>
                        );
                    });
                }}
            </Field>
            <ErrorMessage name={name} component={TextError} />
        </>
    );
}

export default AreasCheckboxes;
